import { firebaseApp } from "./firebase";
import "firebase/firestore";

const firestore = firebaseApp.firestore();
// console.log('process.env.VUE_APP_FB_databaseURL: ', process.env.VUE_APP_FB_databaseURL)
firestore.settings({
  cacheSizeBytes: firestore.CACHE_SIZE_UNLIMITED,
});
firestore.enablePersistence();
// firestore.settings({ timestampsInSnapshots: true })
export default firestore;
